import { fromJS, Map } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  result: [],
  selected_tags: [],
  posts: {},
  pinnedItemsResult: [],
  pinnedItems: {},
  fetching_pinned_items: false,
  post: null,
  highlight_post: {},
  total: null,
  fetching_posts: false,
  post_is_submitting: null,
  no_more_posts: false,
  page: 1,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INIT_POSTS:
      return initialState;

    case ActionTypes.FETCHING_POSTS:
      return state.set('fetching_posts', true).set('highlight_post', Map());

    case ActionTypes.FETCHED_POSTS:
      return state
        .set('page', state.get('page') + 1)
        .set('total', action.payload.total)
        .set('no_more_posts', state.get('posts').size >= action.payload.total)
        .set('fetching_posts', false)
        .set('highlight_post', fromJS(action.payload.highlight_post || {}))
        .mergeIn(
          ['result'],
          state.get('result').push(...action.payload.posts.result),
        )
        .mergeIn(['posts'], fromJS(action.payload.posts.entities.posts));

    case ActionTypes.RESET_POSTS:
      return state.set('result', fromJS([]));

    case ActionTypes.FETCHING_PINNED_ITEMS:
      return state.set('fetching_pinned_items', true);

    case ActionTypes.FETCHED_PINNED_ITEMS:
      return state
        .set('fetching_pinned_items', false)
        .set('pinnedItemsResult', fromJS(action.payload.pinnedItems.result))
        .set('pinnedItems', fromJS(action.payload.pinnedItems.entities.posts));

    case ActionTypes.CREATED_DRAFT_POST:
      return state
        .set('post_is_submitting', false)
        .setIn(['post'], action.payload.topic_post);

    case ActionTypes.UPDATING_POST:
      return state
        .set('post_is_submitting', true)
        .mergeIn(['posts'], fromJS(action.payload.entities.posts));

    case ActionTypes.UPDATED_POST:
      return state
        .set('post_is_submitting', false)
        .mergeIn(['posts'], fromJS(action.payload.entities.posts));

    case ActionTypes.SUBMITTED_POST:
      return state
        .set('post_is_submitting', false)
        .mergeIn(['result'], [action.payload.result, ...state.get('result')])
        .mergeIn(['posts'], fromJS(action.payload.entities.posts));

    case ActionTypes.DELETED_POST:
      return state
        .deleteIn([
          'result',
          String(state.get('result').toJS().indexOf(action.payload.result)),
        ])
        .deleteIn(['posts', action.payload.result.toString()]);

    case ActionTypes.UPDATE_SELECTED_TAGS:
      return state.set('selected_tags', fromJS(action.payload));

    default:
      return state;
  }
};
